import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import ReactOtpInput from "react-otp-input";
import Header from "../../commonComponents/header/Header";
import { useState, useEffect } from "react";
import { authService } from "../../../services/apiInterviewService";
import interviewAuthService from "../../../services/interviewAuthService";
// Images
import otpLoginImg from "../../../assets/images/otp-right-image.svg";
import emailImg from "../../../assets/images/email-icon.svg";
import phoneImg from "../../../assets/images/phone-otp.svg";
import arrowImg from "../../../assets/images/arrow-white-icon.svg";
import LoadingDialog from "../../commonComponents/loader/LoadingDialog";
import CommonSnackbar from "../../commonComponents/snackbar/CommonSnackbar";
import Footer from "../../commonComponents/footer/Footer";

const SlotBookingOTP = () => {
  const navigate = useNavigate();
  const isPhone = sessionStorage.getItem("isPhone");
  const isDirectAssessment = isPhone === "False" || isPhone === "false"; // Handle both boolean and string representations
  const [loaderMessage, setLoaderMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [loginCredentials, setLoginCredentials] = useState({
    email: "",
    phoneNumber: "",
  });
  const [snackbar, setSnackbar] = useState(null);
  const [resendTimer, setResendTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    // Get stored credentials from login screen
    const email = sessionStorage.getItem("login_email");
    const phoneNumber = sessionStorage.getItem("login_phone");
    if (!email || (!isDirectAssessment && !phoneNumber)) {
      // If credentials are not found, redirect back to login
      setSnackbar({
        message: "Session expired. Please login again.",
        type: "failure",
      });
      setTimeout(() => {
        navigate("/screenup-login");
      }, 2000);
      return;
    }
    setLoginCredentials({ email, phoneNumber });

    // Show welcome message
    setSnackbar({
      message: isDirectAssessment
        ? "OTP has been sent to your email."
        : "OTPs have been sent to your email and phone number.",
      type: "success",
    });
  }, [navigate]);

  useEffect(() => {
    // Start countdown timer
    if (resendTimer > 0) {
      const timer = setTimeout(() => {
        setResendTimer(resendTimer - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      setCanResend(true);
    }
  }, [resendTimer]);

  const initialValues = {
    emailOtp: "",
    mobileOtp: "",
    termsAccepted: false,
  };

  const validationSchema = Yup.object({
    emailOtp: Yup.string()
      .length(6, "OTP must be 6 digits")
      .required("Email OTP is required"),
    mobileOtp: isDirectAssessment
      ? Yup.string().notRequired()
      : Yup.string()
        .length(6, "OTP must be 6 digits")
        .required("Mobile OTP is required"),
    termsAccepted: Yup.boolean().oneOf(
      [true],
      "You must accept the terms and conditions",
    ),
  });
  const handleResendOTP = async () => {
    setIsLoading(true);
    setLoaderMessage("Resending OTPs...");
    try {
      const response = await authService.sendSlotBookingOTP(
        loginCredentials.email,
        loginCredentials.phoneNumber,
      );
      setSnackbar({
        message: response.message || "OTPs resent successfully!",
        type: "success",
      });
      setResendTimer(60);
      setCanResend(false);
    } catch (error) {
      setSnackbar({ message: error.message, type: "failure" });
    } finally {
      setIsLoading(false);
    }
  };
  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    setSubmitting(true);
    setLoaderMessage("Verifying OTPs...");
    // Manual validation for snackbar messages
    if (!values.emailOtp) {
      setSnackbar({
        message: "Email OTP is required",
        type: "failure",
      });
      setSubmitting(false);
      return;
    }

    if (values.emailOtp.length !== 6) {
      setSnackbar({
        message: "Email OTP must be 6 digits",
        type: "failure",
      });
      setSubmitting(false);
      return;
    }

    // if (!isDirectAssessment) {
    if (!values.mobileOtp) {
      setSnackbar({
        message: "Mobile OTP is required",
        type: "failure",
      });
      setSubmitting(false);
      return;
    }

    if (values.mobileOtp.length !== 6) {
      setSnackbar({
        message: "Mobile OTP must be 6 digits",
        type: "failure",
      });
      setSubmitting(false);
      return;
    }
    // }

    if (!values.termsAccepted) {
      setSnackbar({
        message: "You must accept the terms and conditions",
        type: "failure",
      });
      setSubmitting(false);
      return;
    }

    setIsLoading(true);
    setError("");
    setSnackbar(null);

    try {
      const response = await authService.verifySlotBookingOTP(
        loginCredentials.email,
        loginCredentials.phoneNumber,
        values.emailOtp,
        values.mobileOtp,
      );

      // Store tokens using the interview auth service
      interviewAuthService.setTokens(
        response.access_token,
        response.refresh_token,
      );

      // Show success message for OTP verification
      setSnackbar({
        message: "OTPs verified successfully!",
        type: "success",
      });

      // Get video SDK token using the access token

      // Store slot/access gate fields so routing below can use them
      //   sessionStorage.setItem("isAllowed", String(response.isAllowed ?? ""));
      //   sessionStorage.setItem("accessReason", response.reason ?? "");
      //   sessionStorage.setItem("accessMessage", response.message ?? "");

      // Clear stored credentials from sessionStorage
      //   sessionStorage.removeItem("login_email");
      //   sessionStorage.removeItem("login_phone");
      // const isProctoringRequired = sessionStorage.getItem("proctoringRequired");

      // Navigate to next screen after showing success message.
      // Routing is based on isAllowed + reason from the verify response.
      setTimeout(() => {
        const isAllowed = response.isAllowed;
        const reason = response.reason;

        // if (isAllowed === "true" || isAllowed === true) {
        //   if (isProctoringRequired === "true" || isProctoringRequired === true)
        //     // Normal flow — proceed to assessment integrity screen
        //     navigate("/assessment-integrity");
        //   //skip intergrity screen and move to verification
        //   else navigate("/verification");
        // } else if (reason === "early") {
        //   // Interview window hasn't opened yet — show the info screen
        //   navigate("/interview-not-open");
        // } else {
        // no_slot / expired / any other isAllowed:false — go to slot booking
        navigate("/slot-booking", {
          state: {
            jobTitle: response.role,
            companyName: response.company_name,
            lastDate: response.last_date,
            candidateName: response.name,
            resumeId: null,
            jobDescriptionId: response.jd_id,
            interviewId: sessionStorage.getItem("interviewId") || null,
            timeDuration: response.time_duration||response.results.time_duration,
            timezone: response.timezone,
            isAssessment: false,
            from: "slot-booking-otp",
          },
        });
        //}
      }, 2000);
    } catch (error) {
      console.error("Error verifying OTP:", error);
      setSnackbar({
        message:
          error.message ||
          "Failed to verify OTPs. Please check your OTPs and try again.",
        type: "failure",
      });
    } finally {
      setIsLoading(false);
      setSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-white pt-4 px-4 font-sans ">
      {isLoading && (
        <LoadingDialog
          title="Verifying OTPs"
          // primaryMSG="Verifying OTPs..."
          primaryMSG="Verifying email and phone One-Time Passcodes..."
          bottomMsg=" This will take just a bit."
        />
      )}
      {snackbar && (
        <CommonSnackbar
          message={snackbar.message}
          type={snackbar.type}
          onClose={() => setSnackbar(null)}
        />
      )}

      <Header />

      {/* ---------- Main Content ---------- */}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        validate={(values) => {
          if (snackbar && snackbar.type === "failure") setSnackbar(null);
          return {};
        }}
      >
        {({
          values,
          handleChange,
          handleBlur,
          setFieldValue,
          isSubmitting,
          submitForm,
        }) => {
          const isDisabled =
            isLoading ||
            isSubmitting ||
            !values.emailOtp ||
            values.emailOtp.length !== 6 ||
            (!isDirectAssessment &&
              (!values.mobileOtp || values.mobileOtp.length !== 6)) ||
            !values.termsAccepted;

          return (
            <>
              <div className="flex-1 flex flex-col md:flex-row w-full overflow-y-auto">
                {/* Left Image */}
                <div className="mt-10 md:mt-0 md:flex w-full md:w-1/2 justify-center items-center pl-[34px] pr-[50px]">
                  <img
                    src={otpLoginImg}
                    alt="login otp"
                    className="object-contain  h-auto w-[100%] rounded-3xl"
                  />
                </div>

                {/* Divider */}
                <div className="hidden md:block border-l border-dividerColor my-[5%]" />

                {/* Right Form Section */}
                <div className="w-full md:w-1/2 flex justify-center items-center px-6 py-8 md:p-[70px]">
                  <div className="w-full md:w-[100%]">
                    <h2 className="app-title font-[500] mb-2 text-fontColor">
                      One-Time Passcode
                    </h2>
                    <p className="app-body text-fontColor">
                      {isDirectAssessment
                        ? "We have sent you a One-Time Passcode to your Email. Please enter it below."
                        : "We have sent you One-Time Passcodes to your Email and Phone. Please enter them below."}
                    </p>

                    <Form className="w-full">
                      {/* Email OTP */}
                      <div className="mt-6">
                        <label className="app-textbox ml-8">
                          Passcode from Email
                        </label>
                        <div className="flex items-center">
                          <img
                            src={emailImg}
                            alt="email"
                            className="h-5 w-5 mr-2"
                          />
                          <ReactOtpInput
                            value={values.emailOtp}
                            onChange={(val) => setFieldValue("emailOtp", val)}
                            numInputs={6}
                            renderInput={(props) => (
                              <input {...props} disabled={isLoading} />
                            )}
                            inputStyle={{
                              width: "clamp(28px, 8vw, 35px)",
                              height: "clamp(32px, 9vw, 40px)",
                              margin: "0 clamp(2px, 1.5vw, 6px)",
                              fontSize: "clamp(14px, 4vw, 18px)",
                              border: "1px solid #002147",
                              borderRadius: "4px",
                              textAlign: "center",
                            }}
                          />
                        </div>
                        <div className="h-4 ml-8"></div>
                      </div>

                      {/* Mobile OTP */}
                      {!isDirectAssessment && (
                        <div className="mt-10">
                          <label className="app-textbox ml-8">
                            Passcode from Phone
                          </label>
                          <div className="flex items-center">
                            <img
                              src={phoneImg}
                              alt="phone"
                              className="h-5 w-5 mr-2"
                            />
                            <ReactOtpInput
                              value={values.mobileOtp}
                              onChange={(val) =>
                                setFieldValue("mobileOtp", val)
                              }
                              numInputs={6}
                              renderInput={(props) => (
                                <input {...props} disabled={isLoading} />
                              )}
                              inputStyle={{
                                width: "clamp(28px, 8vw, 35px)",
                                height: "clamp(32px, 9vw, 40px)",
                                margin: "0 clamp(2px, 1.5vw, 6px)",
                                fontSize: "clamp(14px, 4vw, 18px)",
                                border: "1px solid #002147",
                                borderRadius: "4px",
                                textAlign: "center",
                              }}
                            />
                          </div>
                          <div className="h-4 ml-8"></div>
                        </div>
                      )}

                      {/* Terms */}
                      <div className="mt-10 flex items-start">
                        <input
                          type="checkbox"
                          className="accent-[#111729] mr-2 transition scale-125"
                          name="termsAccepted"
                          checked={values.termsAccepted}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isLoading}
                        />
                        <label className="ml-2 app-note  -mt-0.5">
                          I have read and agree to the{" "}
                          <a
                            href="/privacy-policy.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline"
                          >
                            Privacy Policy
                          </a>{" "}
                          and{" "}
                          <a
                            href="/terms-of-use.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline"
                          >
                            Terms of Use
                          </a>{" "}
                          documents.
                        </label>
                      </div>

                      {/* Resend OTP Section */}

                      <div className="mt-4 flex justify-center items-center gap-6 text-center">
                        {canResend ? (
                          <>
                            <button
                              type="button"
                              onClick={handleResendOTP}
                              disabled={isLoading}
                              className="text-blue-600 underline hover:underline app-textbox font-medium disabled:opacity-50"
                            >
                              Resend OTP
                            </button>
                          </>
                        ) : (
                          <p className="app-textbox text-fontColor">
                            Resend OTPs in{" "}
                            <span className="font-semibold text-logoColor">
                              {resendTimer}s
                            </span>
                          </p>
                        )}
                      </div>
                    </Form>
                  </div>
                </div>
              </div>

              {/* ---------- Bottom Button Bar ---------- */}
              <div className="mt-auto w-full flex justify-end pb-4 ">
                <button
                  type="button"
                  onClick={submitForm}
                  disabled={isDisabled}
                  className="app-button  flex items-center px-6 py-1.5 transition-colors duration-200 bg-btnBgColor text-white disabled:opacity-30 disabled:cursor-not-allowed mr-[36px]"
                >
                  Proceed
                  <img src={arrowImg} alt="arrow" className="ml-2" />
                </button>
              </div>
            </>
          );
        }}
      </Formik>

      <Footer />
    </div>
  );
};

export default SlotBookingOTP;
